import { render, staticRenderFns } from "./ItemCategoryDropdown.vue?vue&type=template&id=449fa38a&"
import script from "./ItemCategoryDropdown.vue?vue&type=script&lang=ts&"
export * from "./ItemCategoryDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports